var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.405,
    height: 48.245,
    viewBox: "0 0 50.405 48.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M89.238,29.7,76.072,28.474l-5.23-12.145a1.055,1.055,0,0,0-1.938,0l-5.23,12.145L50.507,29.7a1.055,1.055,0,0,0-.6,1.843l9.934,8.727-2.907,12.9A1.055,1.055,0,0,0,58.5,54.3l11.37-6.751L81.242,54.3a1.055,1.055,0,0,0,1.568-1.139L79.9,40.266l9.934-8.727A1.055,1.055,0,0,0,89.238,29.7Z",
    transform: "translate(-44.67 -15.227)",
    fill: "#ffdc64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M91.972,11.656c.671.932,2.566,4.936,3.649,7.27a.366.366,0,0,1-.584.42c-1.869-1.767-5.065-4.834-5.737-5.767a1.646,1.646,0,1,1,2.671-1.923Z",
    transform: "translate(-80.229 -10.971)",
    fill: "#fff082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M358.97,11.656c-.671.932-2.566,4.936-3.649,7.27a.366.366,0,0,0,.584.42c1.869-1.767,5.065-4.834,5.737-5.767a1.646,1.646,0,0,0-2.672-1.923Z",
    transform: "translate(-320.307 -10.971)",
    fill: "#fff082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M423.094,283.991c-1.092-.356-5.482-.945-8.034-1.268a.366.366,0,0,0-.223.684c2.252,1.244,6.145,3.357,7.237,3.713a1.646,1.646,0,0,0,1.021-3.13Z",
    transform: "translate(-373.825 -255.967)",
    fill: "#fff082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1.136,283.991c1.092-.356,5.482-.945,8.035-1.268a.366.366,0,0,1,.223.684c-2.252,1.244-6.145,3.357-7.237,3.713a1.646,1.646,0,0,1-1.021-3.13Z",
    transform: "translate(0 -255.967)",
    fill: "#fff082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M239.794,408.032c0-1.149.8-5.505,1.286-8.032a.366.366,0,0,1,.719,0c.484,2.526,1.286,6.883,1.286,8.032a1.646,1.646,0,0,1-3.292,0Z",
    transform: "translate(-216.187 -361.433)",
    fill: "#fff082"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M72.743,20.746l-1.9-4.416a1.055,1.055,0,0,0-1.938,0l-5.23,12.145L50.507,29.7a1.055,1.055,0,0,0-.6,1.843l9.934,8.727-2.907,12.9A1.055,1.055,0,0,0,58.5,54.3l1.513-.9A81.909,81.909,0,0,1,72.743,20.746Z",
    transform: "translate(-44.67 -15.227)",
    fill: "#ffc850"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow-star.ee53b5557aee83181d0bae03ba99020f.svg";
export { ForwardRef as ReactComponent };